<template>
    <div class="mt-3">
        <div class="col-12 d-flex justify-content-between align-items-center px-3">
            <h5 class="col-7 mb-0">Entérate de las últimas novedades</h5>
            <a class="text-secondary col-5 text-end mb-0" :href="`/novedades`">Ver todas ></a>
        </div>
        <slick v-if="dataNoveltys.length" ref="slick" :options="slickOptionsNovedades" class="p-2 slick-vue mb-4">
            <div v-for="(imagenes, index) in dataNoveltys" :key="index" v-if="index < 10" class="my-4  col-3 col-sm-3 col-lg-2">
                <div class=" cursor-pointer mx-2 mx-md-3 mx-lg-4" >
                    <a class="w-100 imgNovedades text-decoration-none" >
                        <img :src="imagenes.novelty_image" class="w-100 h-100 rounded object-fit-xxl-contain">
                        <p class="texto-truck-novedades mb-1 mt-2 text-dark text-bat">{{ imagenes.description }}</p>
                        <a class="text-indigo text-decoration-underline mb-0 mt-2 fs-6 fw-bold text-title-bat" :href="`/detalle-novedades/`+imagenes.id">{{imagenes.title_button_text}} ></a>
                    </a>
                </div>
            </div>
        </slick>

    </div>
</template>
<script>
import Slick from "vue-slick";
import 'slick-carousel/slick/slick.css';
export default {
    components: { Slick },
    data(){
        return {
            dataNoveltys:[],
            slickOptionsNovedades:{
                dots: false,
                arrows: false,
                infinite: true,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: 5,
                slidesToScroll: 1,
                pauseOnFocus: false,
                responsive:[
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    }
                ]
            }
        }
    },
    mounted() {
        this.getNoveltys();
    },
    methods: {
        getNoveltys() {
            axios.get(`/get-news-home`).then(({ data }) => {
                this.dataNoveltys = data.news;
            });
        },
    }
}

</script>
